import { render, staticRenderFns } from "./sales_small_teams.vue?vue&type=template&id=37fbccb6&"
import script from "./sales_small_teams.vue?vue&type=script&lang=js&"
export * from "./sales_small_teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports